import bg from './locale/bg';
import en from './locale/en';
import es from './locale/es';
import kk from './locale/kk';
import pl from './locale/pl';
import ru from './locale/ru';

export default {
  bg,
  en,
  es,
  kk,
  pl,
  ru,
};
